import { MatchPlayerDamageModel, MatchPlayerReceivedDamageModel } from "../../../../api/repositories/stats/models/matches";
import { Hero } from "../../../routes/hero";
import { HeroImage } from "../../ui/file-contents";

export const ReceivedDamageTooltipBlock: React.FC<{
    damage?: MatchPlayerDamageModel
    receivedDamages?: MatchPlayerReceivedDamageModel[]
}> = ({ damage, receivedDamages }) => {
    return <div className="flex flex-col gap-[8px]">
        {receivedDamages?.map((rd, i) => <div key={i} className="flex flex-row gap-[4px] items-center">
            <HeroImage className="h-[50px]" heroName={rd.heroName} size="80x47" />
            <DamageTooltipBlock damage={rd.damage} />
        </div>
        )}
    </div>
}

export const DamageTooltipBlock: React.FC<{
    damage?: MatchPlayerDamageModel
}> = ({ damage }) => {
    if (!damage)
        return null;

    const total = damage.total || 1;

    const physicalPercent = (damage.physical / total) * 100;
    const magicalPercent = (damage.magical / total) * 100;
    const purePercent = (damage.pure / total) * 100;

    const dmgSpanClass = 'text-gray text-[10px]';

    return (
        <div className="flex flex-col gap-[2px]">
            <div className="flex justify-between w-[180px]">
                <div className="flex flex-col">
                    <span className={dmgSpanClass}>physical</span>
                    <span>{damage.physical}</span>
                </div>
                <div className="flex flex-col">
                    <span className={dmgSpanClass}>/</span>
                    <span className={dmgSpanClass}>/</span>
                </div>
                <div className="flex flex-col">
                    <span className={dmgSpanClass}>magical</span>
                    <span>{damage.magical}</span>
                </div>
                <div className="flex flex-col">
                    <span className={dmgSpanClass}>/</span>
                    <span className={dmgSpanClass}>/</span>
                </div>
                <div className="flex flex-col">
                    <span className={dmgSpanClass}>pure</span>
                    <span>{damage.pure}</span>
                </div>
            </div>

            <div className="relative flex h-[8px] rounded overflow-hidden bg-neutral-300">
                {physicalPercent > 0 && (
                    <div
                        className="absolute left-0 h-full bg-red-500"
                        style={{ width: `${physicalPercent}%` }}
                    />
                )}
                {magicalPercent > 0 && (
                    <div
                        className="absolute h-full bg-blue-500"
                        style={{ left: `${physicalPercent}%`, width: `${magicalPercent}%` }}
                    />
                )}
                {purePercent > 0 && (
                    <div
                        className="absolute h-full bg-yellow-400"
                        style={{ left: `${physicalPercent + magicalPercent}%`, width: `${purePercent}%` }}
                    />
                )}
            </div>
        </div>
    );
};